module.exports = __webpack_public_path__ + "img/ForkLiftCabin.db6a9872.png";